import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { HOME_PATHS, parentPath } from '../lib/nav';

/* ─────────────────────────────────────────────────────────────
   The single global "← Back" affordance. Sits just below the
   header on every route EXCEPT a hub (Home). Pages must NOT add
   their own back arrows.

   Back logic: if there is in-app history (location.key !==
   'default'), step back one entry; otherwise fall back to the
   route's logical parent so the button is never a dead end.
───────────────────────────────────────────────────────────── */
export default function PageBackBar() {
  const location = useLocation();
  const navigate = useNavigate();

  if (HOME_PATHS.has(location.pathname)) return null;

  const goBack = () => {
    if (location.key && location.key !== 'default') navigate(-1);
    else navigate(parentPath(location.pathname));
  };

  return (
    <div className="scpa-backbar">
      <button
        type="button"
        onClick={goBack}
        className="inline-flex items-center gap-1.5"
        style={{ fontSize: 13, fontWeight: 600, color: 'var(--scpa-text-muted)', background: 'none', border: 'none', cursor: 'pointer' }}
      >
        <ArrowLeft className="w-4 h-4" /> Back
      </button>
    </div>
  );
}
